import { CheckIcon } from "@heroicons/react/outline";
import { DocumentDuplicateIcon } from "icons/outline";
import React from "react";
import { cn, Tooltip, useCopyToClipboard } from "ui";

type CopyIconButtonProps = {
  text: string;
  className?: string;
  iconClassName?: string;
  disableTooltip?: boolean;
  isInfo?: boolean;
};
export default function CopyIconButton(props: CopyIconButtonProps) {
  if (props.disableTooltip) return <CopyIconButtonWithoutTooltip {...props} />;
  return (
    <Tooltip content="Copy" size="sm">
      <CopyIconButtonWithoutTooltip {...props} />
    </Tooltip>
  );
}

const CopyIconButtonWithoutTooltip = React.forwardRef<
  HTMLButtonElement,
  CopyIconButtonProps
>(({ text, className, iconClassName, isInfo }, ref) => {
  const { copy, isCopied } = useCopyToClipboard();

  return (
    <button
      ref={ref}
      type="button"
      onClick={() => {
        if (isCopied) return;
        copy(text);
      }}
      className={cn("group", className)}
      aria-label="Copy to clipboard"
    >
      {isCopied ? (
        <CheckIcon
          className={cn("h-4 w-4 text-success", iconClassName)}
          aria-hidden="true"
        />
      ) : (
        <DocumentDuplicateIcon
          className={cn(
            "h-4 w-4 stroke-2 ",
            isInfo
              ? "text-info"
              : "text-foundations-subtler group-hover:text-foundations-subtle",
            iconClassName
          )}
        />
      )}
    </button>
  );
});
CopyIconButtonWithoutTooltip.displayName = "CopyIconButtonWithoutTooltip";
